module.exports = __webpack_public_path__ + "media/images/adcurve_favicon-eb93ff5c119fedca0527412d2380fdaa.png";